export default function reportError(err, extra) {
  console.warn(err.message, extra, err)

  if (
    typeof window !== 'undefined' &&
    window.Raven &&
    window.Raven.captureExpression
  ) {
    window.Raven.captureException(err, { extra })
  }
}
